import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import {
  EbContactFormOccInterface,
  EbContactUsTopics
} from '../interfaces/eb-contact-form.interface'

export const CONTACT_US_TOPICS_NORMALIZER = new InjectionToken<Converter<any, EbContactUsTopics>>(
  'ContactUsTopicsNormalizer'
)

export const CONTACT_US_SERIALIZER = new InjectionToken<Converter<any, EbContactFormOccInterface>>(
  'ContactUsTopicsNormalizer'
)
